var ratio = 1;
var formSubmitted = false;

import './bootstrap';
import questions from './questions';
import localStorage from './localstorage';
import animateCss from './animate';
import results from './results';
import landscapeModal from './landscape';

const debugstate = false;

document.addEventListener('DOMContentLoaded', function () {
    window.debug = function (msg) { debugstate ? console.log(msg) : null; }

    window.debug('debug: DOMContentLoaded');

    localStorage();

    window.addEventListener('resize', landscapeModal);
    landscapeModal();

    // scale page
    function scalePage(target) {
        var CW = document.documentElement.clientWidth;
        var W = 1112;

        ratio = (CW / W);

        document.querySelectorAll(target).forEach(function(el) {
            if (navigator.userAgent.indexOf("Firefox") != -1) {
                el.style.transform = 'scale(' + ratio + ')';
            } else {
                el.style.zoom = (ratio*100) + '%';
            }

            fullpage_api.moveTo(window.location.hash.substring(1));
        });
    }

    window.addEventListener('resize', function() { scalePage('.panel-container'); });
    window.onload = function() { scalePage('.panel-container'); };

    const result = document.getElementById('result');

    if (document.querySelectorAll('#fullpage').length) { // don't setup fullpage on the back-end pages

        questions();

        // set up fullpage
        new fullpage('#fullpage', {
            licenseKey: 'QMB57-6NJVJ-8JNWI-7D4QK-KBEWM',
            autoScrolling: true,
            scrollOverflow: true,
            // normalScrollElements: '.panel-container',
            anchors: ['m1','m2','m3','m4','m5','m6','m7','m8',],
            beforeLeave: function(origin, destination, direction, trigger) {
                // prevent visiting results page if questions aren't answered
                if (destination.anchor == 'm8' && !correctNumberOfAnswers()) {
                    return false;
                }

                // origin anchor index matches up with question section id for question sections
                // index 0 - intro section
                // index 1 - question 1 section etc.
                let originAnchorIndex = parseInt(origin.anchor.substring(1)) - 1;
                // check if question section for a given anchor index exists
                let originIsQuestionSection = document.querySelectorAll('#question-' + originAnchorIndex).length > 0;

                if (originAnchorIndex == 6 && !formSubmitted) {
                    return false; // don't skip the form screen
                }

                // if someone is trying to go down, inside a question section and they haven't ticked the required number of answers
                if(direction == 'down' && originIsQuestionSection && !correctNumberOfAnswers(originAnchorIndex)) {
                    // bail it
                    return false;
                }

                // animate options on section entry
                destination.item.querySelectorAll('.animate').forEach(el => {
                    animateCss(el, 'zoomIn', '1s');
                });
            },
        });

        // Add click event listeners to buttons
        document.querySelectorAll('.js-next').forEach(nextButton => {
            nextButton.addEventListener('click', (event) => {
                event.preventDefault();

                const currentIndex = parseInt(nextButton.dataset.current);
                const currentSection = document.querySelector('#fullpage > :nth-child(' + currentIndex + ')');

                if(currentSection.classList.contains('js-question-section')) {
                    const checkedCheckboxes = currentSection.querySelectorAll("input[type='checkbox']:checked");
                    const questionIndex = getIndexFromId(currentSection.id) - 1;
                    const requiredAnswersCount = window.questions[questionIndex].required_answers_count;

                    if (checkedCheckboxes.length !== requiredAnswersCount) {
                        showError(`Please select ${requiredAnswersCount} ${requiredAnswersCount == 1 ? 'option' : 'options'}`);
                    } else {
                        formSubmitted = true;
                        if(currentSection.classList.contains('js-last-question-section')) {
                            let result = calculateResults();

                            if(result !== false) {
                                fullpage_api.moveTo('m' + (currentIndex + 1), 1);
                            }
                        } else {
                            fullpage_api.moveTo('m' + (currentIndex + 1), 1);
                        }
                    }
                } else if(currentSection.classList.contains('js-form-section')) {

                    if (!event.target.classList.contains('skip')) {
                        const name = document.getElementById('signup-name').value;
                        const email = document.getElementById('signup-email').value;
                        const type = document.getElementById('signup-type').value;
                        const newsletter = document.getElementById('signup-newsletter').value;

                        // opted in - check for required fields
                        if (name == '' || email == '' || type == '') {
                            showError('Please complete the form');
                            return;
                        } else {
                            window.storeDataLocally({
                                name: name,
                                email: email,
                                type: type,
                                newsletter: newsletter,
                                when: Date(),
                            });
                        }
                    }

                    let result = calculateResults();

                    if(result !== false) {
                        fullpage_api.moveTo('m' + (currentIndex + 1), 1);
                    }
                } else {
                    fullpage_api.moveTo('m' + (currentIndex + 1), 1);
                }
            });
        });
    }

    document.querySelectorAll('.option-container input[type="checkbox"]').forEach(checkbox => {
        checkbox.addEventListener('change', () => {
            const section = document.getElementById(checkbox.getAttribute('name'));

            updateCurrentHtml(section, checkbox);
        });
    });

    // remove selected option on click
    document.querySelectorAll('.js-question-section').forEach(section => {
        section.querySelectorAll('.js-selected-option-current > div').forEach(selectedOption => {
            selectedOption.addEventListener('click', () => {
                const checkbox = section.querySelector('.uk-child-width-1-5 > div:nth-child(' + getIndexFromSrc(selectedOption.querySelector('img').getAttribute('src')) + ') input');

                checkbox.checked = false;
                updateCurrentHtml(section, checkbox);
            });
        });
    });

    if (document.querySelectorAll('#data-counter').length) {
        window.getCount();
    }

    function calculateResults() {
        let scores = {};
        let inputs = document.querySelectorAll('.option-container input[type="checkbox"]:checked.option-checkbox');

        if(!correctNumberOfAnswers()) {
            showError('Please select required number of answers per question.');
            return false;
        }

        inputs.forEach(input => {
          scores[input.value] = (scores[input.value] || 0) + 1;
        });

        // Sort results by score in descending order
        let sortedResults = Object.entries(scores).sort((a, b) => b[1] - a[1]);
        window.sortedResults = sortedResults;
        const title = sortedResults[0][0];

        const resultData = results[title];

        result.querySelector('h2').innerText = title;
        result.querySelector('p').innerText = resultData.description;
        result.querySelector('a:first-of-type').setAttribute('href', resultData.stockist);
        result.querySelector('a:last-of-type').setAttribute('href', resultData.collection);

        // populate the slideshow with results images
        let imagesHtml = '';

        resultData.images.forEach((src, index) => {
            imagesHtml += `
                <li ${index == 0 ? 'class="uk-active"' : ''}>
                    <img src="${src}" alt="${title} style example ${index + 1}" uk-cover loading="lazy">
                </li>
            `;
        });

        document.querySelector('#result-slideshow-wrapper .uk-slideshow-items').innerHTML = imagesHtml;
    }

    function showError(message) {
        UIkit.notification({
            message: message,
            status: 'danger',
        });
    }

    function getIndexFromId(id) {
        return parseInt(id.substring(id.indexOf('-') + 1));
    }

    function getIndexFromSrc(src) {
        return parseInt(src.substring(src.lastIndexOf('/') + 1).substring(0, 1));
    }

    function updateExpectedSrcs(questionIndex, src, add) {
        // if we want to add src to expectedSrcs
        if(add) {
            let emptyIndex = -1;

            // go through expectedSrcs and see if there is a space for another one
            // if 1 answer - empty index is -1 when an answer already ticked and 0 if no answer ticked yet
            // if 2 answers - empty index is -1 when both ticked and the first available index if otherwise
            // with no answers ticked it's 0, with 1 it's 1
            window.questions[questionIndex].expectedSrcs.forEach((expectedSrc, index) => {
                if(expectedSrc == '' && emptyIndex == -1) {
                    emptyIndex = index;
                }
            });

            // and there is no empty index to set it to
            if(emptyIndex == -1) {
                // move all answers one back
                for(let i = 1; i < window.questions[questionIndex].expectedSrcs.length; i++) {
                    window.questions[questionIndex].expectedSrcs[i - 1] = window.questions[questionIndex].expectedSrcs[i];
                }

                // and add changedSrc to the end
                window.questions[questionIndex].expectedSrcs[window.questions[questionIndex].expectedSrcs.length - 1] = src;
            // and there is an empty index to set it to
            } else {
                // just put it on the empty index
                window.questions[questionIndex].expectedSrcs[emptyIndex] = src;
            }
        // if we want to remove changed from answers
        } else {
            // first splice it from the expectedSrcs
            window.questions[questionIndex].expectedSrcs.forEach((expectedSrc, index) => {
                if(expectedSrc == src) {
                    window.questions[questionIndex].expectedSrcs.splice(index, 1);
                }
            });

            // and then add an empty src to the end of expectedSrcs
            window.questions[questionIndex].expectedSrcs[window.questions[questionIndex].expectedSrcs.length] = '';
        }
    }

    function stopCurrentAnimation() {
        const clone = document.querySelector('.clone');

        if(clone) {
            const target = document.getElementById(clone.dataset.target);
            target.setAttribute('src', clone.getAttribute('src'));

            if(clone.getAttribute('src').includes('empty')) {
                target.parentNode.classList.remove('populated');
            } else {
                target.parentNode.classList.add('populated');
            }

            clone.remove();
        }
    }

    function updateCurrentHtml (section, changed) {
        stopCurrentAnimation();

        const selectedOptionCurrent = section.querySelector('.js-selected-option-current');
        let theme;

        if(section.classList.contains('light-theme')) {
            theme = 'light';
        } else {
            theme = 'dark';
        }

        const questionIndex = getIndexFromId(section.id) -1;
        const changedImg = changed.parentElement.querySelector('img');

        updateExpectedSrcs(questionIndex, changedImg.getAttribute('src'), changed.checked);

        // make sure that checkboxes checked matches up with expectedSrcs
        section.querySelectorAll('.option-container input[type="checkbox"]:checked').forEach(checkbox => {
            checkbox.parentElement.querySelectorAll('img').forEach(img => {
                if(window.questions[questionIndex].expectedSrcs.findIndex(value => window.location.origin + value == img.src) === -1) {
                    checkbox.checked = false;
                }
            });
        });

        // update answer srcs to match with expectedSrcs
        window.questions[questionIndex].expectedSrcs.forEach((src, index) => {
            const img = selectedOptionCurrent.querySelector(':nth-child(' + (index + 1) + ') > img');
            let expectedSrc;

            if(src != '') {
                expectedSrc = src;
            } else {
                if (section.id == 'question-2') {
                    expectedSrc = `/_/img/empty-2.svg`;
                } else if (section.id == 'question-4') {
                    expectedSrc = `/_/img/empty-4.svg`;
                } else {
                    expectedSrc = `/_/img/empty-${theme}.svg`;
                }
            }

            if(img.getAttribute('src') != expectedSrc) {
                if(!expectedSrc.includes('empty')) {
                    let initialPosition = changedImg.getBoundingClientRect();
                    let finalPosition = img.getBoundingClientRect();

                    const clone = changedImg.cloneNode();
                    clone.classList.add('clone');
                    clone.dataset.target = img.id;
                    clone.style.position = 'absolute';
                    clone.style.left = 0;
                    changedImg.parentNode.appendChild(clone);

                    var deltaX = ((finalPosition.left - initialPosition.left) / ratio) - (img.offsetWidth / ratio);
                    var deltaY = ((finalPosition.top - initialPosition.top) / ratio) - (img.offsetHeight / ratio);

                    clone.style.transition = 'all 0.5s ease-in-out';
                    clone.style.transformOrigin = 'center';
                    clone.style.transform = `translate(${deltaX}px, ${deltaY}px) scale(${img.offsetWidth / changedImg.offsetWidth})`;
                    clone.style.opacity = 0;

                    setTimeout(function() {
                        if(document.querySelector('.clone')) {
                            img.setAttribute('src', expectedSrc);
                            img.parentNode.classList.add('populated');
                            clone.remove();

                            updateBeforeHtml(section);
                        }
                    }, 500);
                } else {
                    img.setAttribute('src', expectedSrc);
                    img.parentNode.classList.remove('populated');

                    updateBeforeHtml(section);
                }
            }
        })
    }

    function updateBeforeHtml(section) {
        const question = getIndexFromId(section.id);

        section.querySelectorAll('.js-selected-option-current > div > img').forEach((selectedOption, index) => {
            document.querySelectorAll(`.js-selected-options-before [data-question="${question}"][data-answer="${index + 1}"]`).forEach(img => {
                img.setAttribute('src', selectedOption.getAttribute('src'));
                img.setAttribute('alt', selectedOption.getAttribute('alt'));
            });
        });
    }

    function correctNumberOfAnswers(currentQuestion) {
        // if currentQuestion provided, check within question section, otherwise in document
        const parent = currentQuestion ? document.getElementById('question-' + currentQuestion) : document;
        // get the number of answers in section/document
        let answersCount = parent.querySelectorAll('.option-container input[type="checkbox"]:checked').length;
        let requiredAnswers = 0;

        // if currentQuestion provided
        if(currentQuestion) {
            // requiredAnswers is equal to required_answers_count for that question
            requiredAnswers = window.questions[currentQuestion - 1].required_answers_count;
        // otherwise
        } else {
            // requiredAnswers is a sum of all required_answers_count
            window.questions.forEach(question => {
                requiredAnswers += question.required_answers_count;
            });
        }

        return answersCount === requiredAnswers;
    }
});
